import PurchaseNormalizersResolver from './PurchaseNormalizersResolver';
import AbstractDataBuilder from "../../core/AbstractDataBuilder";
export default class PurchaseDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new PurchaseNormalizersResolver());
        }
        return this.builderInstance;
    }
}
